import {
  type CabinetInventory,
  getCabinetInventory,
  getRecentSwaps,
  type SwapRecord,
} from '$lib/powerhiveApi';

let selectedCabinetId = $state<string | null>(null);
let inventory = $state<CabinetInventory | null>(null);
let swaps = $state<SwapRecord[]>([]);
let loading = $state(false);
let error = $state<string | null>(null);
/** Epoch ms of the last completed load, for the modal's freshness line. */
let updatedAt = $state<number | null>(null);

let abortController: AbortController | null = null;

export const cabinetInventory = {
  get selectedCabinetId() {
    return selectedCabinetId;
  },
  get inventory() {
    return inventory;
  },
  get swaps() {
    return swaps;
  },
  get loading() {
    return loading;
  },
  get error() {
    return error;
  },
  get updatedAt() {
    return updatedAt;
  },

  async inspect(cabinetId: string): Promise<void> {
    if (!cabinetId) return;
    abortController?.abort();
    const ac = new AbortController();
    abortController = ac;

    selectedCabinetId = cabinetId;
    loading = true;
    error = null;

    try {
      const [invResult, swapsResult] = await Promise.allSettled([
        getCabinetInventory(cabinetId, ac.signal),
        getRecentSwaps(30, ac.signal),
      ]);

      if (ac.signal.aborted) return;

      if (invResult.status === 'fulfilled') {
        inventory = invResult.value;
      } else {
        inventory = null;
      }

      if (swapsResult.status === 'fulfilled') {
        // Filter swaps for this specific cabinet if cabinetId is present
        const allSwaps = swapsResult.value;
        swaps = allSwaps.filter(
          (s) =>
            !s.cabinet_id || s.cabinet_id.toLowerCase().trim() === cabinetId.toLowerCase().trim(),
        );
      } else {
        swaps = [];
      }

      if (invResult.status === 'rejected' && swapsResult.status === 'rejected') {
        const err = invResult.reason;
        error = err instanceof Error ? err.message : String(err);
      } else {
        updatedAt = Date.now();
      }
    } catch (e) {
      if (!ac.signal.aborted) {
        error = e instanceof Error ? e.message : String(e);
      }
    } finally {
      if (abortController === ac) {
        loading = false;
        abortController = null;
      }
    }
  },

  close(): void {
    abortController?.abort();
    abortController = null;
    selectedCabinetId = null;
    inventory = null;
    swaps = [];
    loading = false;
    error = null;
    updatedAt = null;
  },
};
